import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import React from 'react';
import { IllustratedCardStyles as S } from './IllustratedCard.styles';
const IllustratedCard = ({ heading, illustration, link, summary, }) => {
    return (React.createElement(S.Container, null,
        link && React.createElement(S.OverlayLink, { href: link.url, title: link.text, target: link.target ?? '_self' }),
        React.createElement(S.Content, null,
            heading && React.createElement(S.Heading, null, heading),
            summary && React.createElement(S.Summary, { dangerouslySetInnerHTML: { __html: summary } }),
            link && (React.createElement(S.FakeLink, null,
                link.text,
                getSvgFromSystem(SystemIcon.ArrowRight)))),
        illustration && (React.createElement(S.IllustrationWrapper, null,
            React.createElement(S.Illustration, { src: illustration.src, alt: illustration.altText ?? '', role: illustration.altText ? 'presentation' : '', loading: "lazy" })))));
};
export default IllustratedCard;
